<div class="wrap pb-5 pb-lg-5">
    <p class="faq-heading pb-3 pb-lg-4 mb-0">FAQ's</p>
    <div class="faq-group">
        <div class="row">
            <div class="faq-item px-md-0" *ngFor="let que of faqsData">
                <!-- input stays, but no real radio logic -->
                <input type="radio" name="faq" [id]="que?.product_faqs_key" class="faq-input"
                    [checked]="openFaq === que?.product_faqs_key" />
                <div class="faq-row col-12 col-md-12">
                    <div class="faq-question" (click)="toggleFaq(que.product_faqs_key)">
                        <h3 class=" col-10 quest-faq" [innerHTML]="que?.question"></h3>
                        <div class="answer-toggler d-none"> <!-- Functionality not developed yet-->
                            <a (click)="naviagteToPostAnswer()" class="answer-link mb-5 mb-md-0 cursor-pointer">Answer this
                                question</a>
                        </div>
                    </div>
                    <div class="toggler">
                        <!-- remove "for", only use click to toggle -->
                        <label class="col-1 faq-toggle" (click)="toggleFaq(que.product_faqs_key)">
                        </label>
                    </div>
                </div>
                <!-- Only show if open-->
                <div class="faq-answer col-12 col-md-12" *ngIf="openFaq === que?.product_faqs_key">
                    <p [innerHTML]="que?.answer"></p>
                    <div class="answer-actions d-none"><!-- display none for now because functionality not develop yet-->
                        <div class="d-flex align-items-center">
                            <div class="vote"><i class="fa-regular fa-thumbs-up"></i> <span>8</span></div>
                            <div class="vote ms-3"><i class="fa-regular fa-thumbs-down"></i> <span>4</span></div>
                        </div>
                        <div class="answer-links ms-3 d-flex">
                            <a (click)="naviagteToPostAnswer()" class="cursor-pointer">Post an answer</a>
                            <a href="#">Report</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>